export const getFileFormat = (format: string) => {
  if (!format) {
    return "";
  }

  return format.split("/")[1];
};
